export default "__VITE_ASSET__5f28de13__"